import "./ClientRegistrationMedicalHistorySurgicalHistoryComponent.scss";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import * as Yup from "yup";
import _ from "lodash";
import FormikTextAreaComponent
    from "../../../../shared/components/form-controls/formik-text-area/FormikTextAreaComponent";
import {useDispatch, useSelector} from "react-redux";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import CheckBoxComponent from "../../../../shared/components/form-controls/check-box/CheckBoxComponent";
import FormikCheckBoxComponent
    from "../../../../shared/components/form-controls/formik-check-box/FormikCheckBoxComponent";
import {IRootReducerState} from "../../../../store/reducers";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {ImageConfig, Misc} from "../../../../constants";
import {setFormChangesData} from "../../../../store/actions/form-state.action";

interface ClientRegistrationMedicalHistorySurgicalHistoryComponentProps {
    onNext: () => void;
    appointmentId: any
}

// interface Option {
//     title: string;
//     _id: string;
// }

const ClientSurgicalHistoryValidationSchema = Yup.object({
    surgical_history: Yup.object({
        isCustomOption: Yup.boolean().nullable(),
        questions: Yup.array().min(0),
        comments: Yup.string().when("isCustomOption", {
            is: true,
            then: Yup.string().required('Comments is required'),
            otherwise: Yup.string().nullable()
        })
    }),
});

const ClientSurgicalHistoryInitialValues: any = {
    surgical_history: {
        questions: [],
        isCustomOption: false,
        comments: ""
    }
};

const ClientRegistrationMedicalHistorySurgicalHistoryComponent = (props: ClientRegistrationMedicalHistorySurgicalHistoryComponentProps) => {

    const {onNext, appointmentId} = props;
    const {surgicalHistoryOptionsList} = useSelector((state: IRootReducerState) => state.staticData);
    const [clientSurgicalHistoryInitialValues, setClientSurgicalHistoryInitialValues] = useState<any>(_.cloneDeep(ClientSurgicalHistoryInitialValues));
    const dispatch = useDispatch();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const {
        clientMedicalHistoryDetails,
    } = useSelector((state: IRootReducerState) => state.client);

    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            if (clientMedicalHistoryDetails?.surgical_history?.comments) {
                clientMedicalHistoryDetails.surgical_history.isCustomOption = true;
            }
            setClientSurgicalHistoryInitialValues({
                surgical_history: clientMedicalHistoryDetails.surgical_history || []
            });
        }
    }, [clientMedicalHistoryDetails]);

    const onSubmit = useCallback((values: any, {setErrors, setSubmitting}: FormikHelpers<any>) => {
        const payload = {
            ...CommonService.removeKeysFromJSON(_.cloneDeep(values), ['questions_details']),
            appointment_id: appointmentId ? appointmentId : currentUser?.appointment_id,
            client_id: currentUser?._id,
        };
        setSubmitting(true);
        CommonService._client.ClientMedicalHistorySurgicalHistoryDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setSubmitting(false);
                setClientSurgicalHistoryInitialValues(_.cloneDeep(values));
                dispatch(setFormChangesData(false));
                onNext();
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error, true);
                setSubmitting(false);
            })
    }, [onNext, currentUser, dispatch, appointmentId]);

    const handleSurgicalHistoryOptionSelection = useCallback((optionId: string, selectedOptions: string[]) => {
        const options = _.cloneDeep(selectedOptions);
        const index = options?.findIndex((value: string) => value === optionId);
        if (index > -1) {
            options.splice(index, 1);
        } else {
            options.push(optionId);
        }
        return options;
    }, []);

    const midIndex = Math.ceil(surgicalHistoryOptionsList.length / 2);
    const column1 = surgicalHistoryOptionsList.slice(0, midIndex);
    const column2 = surgicalHistoryOptionsList.slice(midIndex);
    return (
        <div className={'client-registration-medical-history-surgical-history-component'}>
            <div className={'client-registration-form-description'}>Have you ever had:</div>
            <Formik
                validationSchema={ClientSurgicalHistoryValidationSchema}
                initialValues={clientSurgicalHistoryInitialValues}
                onSubmit={onSubmit}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}>
                {({
                      values,
                      isSubmitting,
                      setFieldTouched,
                      setFieldValue,
                      setFieldError,
                      isValid,
                      validateForm,
                      dirty,
                      errors
                  }) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                        if (dirty) {
                            dispatch(setFormChangesData(true));
                        }
                    }, [validateForm, values, dirty]);
                    return (
                        <Form noValidate={true} className={"t-form pdd-top-20"}>
                            <div className="t-form-controls">
                                <div className="ts-row">
                                    {/*{*/}
                                    {/*    surgicalHistoryOptionsList?.map((option: ISurgicalHistoryOption) => {*/}
                                    {/*        return <div className="ts-col-lg-6" key={option._id}>*/}
                                    {/*            <Field*/}
                                    {/*                name={"surgical_history.questions"}>*/}
                                    {/*                {(field: FieldProps) => (*/}
                                    {/*                    <CheckBoxComponent*/}
                                    {/*                        id={'cb_' + option?.title}*/}
                                    {/*                        label={option?.title}*/}
                                    {/*                        checked={field.field?.value?.indexOf(option._id) > -1}*/}
                                    {/*                        onChange={() => {*/}
                                    {/*                            setFieldTouched(field.field?.name);*/}
                                    {/*                            setFieldValue(field.field?.name, handleSurgicalHistoryOptionSelection(option._id, field.field?.value));*/}
                                    {/*                            validateForm();*/}
                                    {/*                        }}*/}
                                    {/*                    />*/}
                                    {/*                )}*/}
                                    {/*            </Field>*/}
                                    {/*        </div>*/}
                                    {/*    })*/}
                                    {/*}*/}

                                    <div className={'ts-col-md-6'}>
                                        {column1.map((item) => (

                                            <Field
                                                name={"surgical_history.questions"}>
                                                {(field: FieldProps) => (
                                                    <CheckBoxComponent
                                                        id={'cb_' + item?.title}
                                                        label={item?.title}
                                                        checked={field.field?.value?.indexOf(item._id) > -1}
                                                        onChange={() => {
                                                            setFieldTouched(field.field?.name);
                                                            setFieldValue(field.field?.name, handleSurgicalHistoryOptionSelection(item._id, field.field?.value));
                                                            validateForm();
                                                        }}
                                                    />
                                                )}
                                            </Field>

                                        ))}
                                    </div>
                                    <div className={'ts-col-md-6'}>
                                        {column2.map((item) => (
                                            <div key={item._id}>
                                                <Field
                                                    name={"surgical_history.questions"}>
                                                    {(field: FieldProps) => (
                                                        <CheckBoxComponent
                                                            id={'cb_' + item?.title}
                                                            label={item?.title}
                                                            checked={field.field?.value?.indexOf(item._id) > -1}
                                                            onChange={() => {
                                                                setFieldTouched(field.field?.name);
                                                                setFieldValue(field.field?.name, handleSurgicalHistoryOptionSelection(item._id, field.field?.value));
                                                                validateForm();
                                                            }}
                                                        />
                                                    )}
                                                </Field>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="ts-col-lg-6">
                                        <Field
                                            name={"surgical_history.isCustomOption"}>
                                            {(field: FieldProps) => (
                                                <FormikCheckBoxComponent
                                                    id={"other_cb"}
                                                    formikField={field}
                                                    label={"Other Surgery not Listed?"}
                                                    onChange={(isChecked) => {
                                                        if (!isChecked) {
                                                            setFieldValue('surgical_history.comments', "");
                                                            setFieldError('surgical_history.comments', undefined);
                                                            setTimeout(() => { // TODO solve fool proof
                                                                validateForm();
                                                            }, 10);
                                                        }
                                                    }}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                </div>


                                {values.surgical_history?.isCustomOption && <div className="ts-row">
                                    <div className="ts-col-12">
                                        <Field name={`surgical_history.comments`}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikTextAreaComponent
                                                        id={"comments"}
                                                        label={"Comments"}
                                                        rows={'5'}
                                                        placeholder={"Enter your comments here"}
                                                        disabled={!values.surgical_history?.isCustomOption}
                                                        required={values.surgical_history?.isCustomOption}
                                                        formikField={field}
                                                        fullWidth={true}
                                                        autoFocus={true}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                </div>}
                                <div className="t-form-actions">
                                    <ButtonComponent
                                        id={"next_btn"}
                                        type={"submit"}
                                        size={'large'}
                                        isLoading={isSubmitting}
                                        disabled={!isValid || isSubmitting}
                                        suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                    >
                                        {values?.surgical_history?.questions?.length > 0 || values?.surgical_history?.comments !== '' ? 'Next' : 'Skip'}
                                    </ButtonComponent>
                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    );

};

export default ClientRegistrationMedicalHistorySurgicalHistoryComponent;
